export default __webpack_public_path__ + "static/media/RAISE.02ecb8f8.wav";